module.exports = __webpack_public_path__ + "assets/edit.c7658c1ec50c60ab99197828dbb09a12.png";